import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["idInput"]

  // This works like the mover_controller, look at that to see how the trick works
  connect() {
    var checkboxSelectAll = document.querySelector('#datatable')["checkbox-select-all"] // Uses the trick to access the checkbox-select-all controller

    var checked_values = checkboxSelectAll.checked.map(function (el) {
      return el.value
    })
    this.idInputTarget.value = JSON.stringify(checked_values)
  }
}